"use client";

import Filter from "./Filter";
import BoxWithTitle from "../BoxWithTitle";
import { IBlogsCategory } from "@/api/AppApi/services/blogs/interfaces/IBlogs";

interface props {
  title: string;
  fkey: string;
  filters: IBlogsCategory[];
}

const Filters: React.FC<props> = ({ title, filters, fkey }) => {
  if (!filters || filters?.length === 0) return null;
  return (
    <BoxWithTitle title={title}>
      <ul className="m-0 p-0" style={{ listStyleType: "none" }}>
        {filters?.map((filter) => (
          <li key={filter?.key}>
            <Filter fkey={fkey} filter={filter} />
          </li>
        ))}
      </ul>
    </BoxWithTitle>
  );
};

export default Filters;
